import HTTP from '../HTTP';

const URL_BASE = 'commun/Civilite/';

export async function update(civilite) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', civilite);
  return response;
}

export async function create(civilite) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', civilite);
  return response;
}
